import React from 'react';
import { Typography, Link } from '@hpi-sox/hpstellar-core';

import useTemplateTheme from '../../../hooks/useTemplateTheme';
import useChat from '../../../hooks/useChat';
import './help-section.less';

export default ({
    callCenterNumber = '1-888-650-1543',
    chatRule = 'CTO Chat',
    chatFrom = 'CTO',
    chatReferer = 'CTO',
}) => {
    const { typography } = useTemplateTheme(['typography']);
    const { primaryLinkClassName } = typography || {};
    const { openChat } = useChat({
        chatRule,
        chatFrom,
        chatReferer,
    });
    return (
        <div className="cto-help-section">
            <Typography variant="bodyL" className="help-label">
                NEED HELP? CONTACT US NOW
            </Typography>
            <Link
                variation="body"
                size="small"
                className={`web-chat${primaryLinkClassName ? ` ${primaryLinkClassName}` : ''}`}
                onClick={openChat}
            >
                Chat now
            </Link>
            <Typography variant="bodyS" className="help-number">
                {`Call: ${callCenterNumber}`}
            </Typography>
        </div>
    );
};
